(() => {
  const forms = document.querySelectorAll('[data-hm-purchase]');
  const updateReturns = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('hd_lang');
    document.querySelectorAll('[data-hm-return]').forEach(input => {
      input.value = url.pathname + url.search;
    });
  };
  const addBusinessDays = (start, days) => {
    const date = new Date(start.getTime());
    let remaining = days;
    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) remaining -= 1;
    }
    return date;
  };
  const deliveryText = (node, locale, now = new Date()) => {
    const min = Number(node.dataset.hmDeliveryMin);
    const max = Number(node.dataset.hmDeliveryMax);
    if (!(min > 0) || !(max >= min)) return '';
    const format = new Intl.DateTimeFormat(locale || undefined, { month: 'long', day: 'numeric' });
    return node.dataset.hmDeliveryTemplate
      .replace('__FROM__', format.format(addBusinessDays(now, min)))
      .replace('__TO__', format.format(addBusinessDays(now, max)));
  };
  forms.forEach(form => {
    const scope = (form.closest && form.closest('.hm-sale')) || form;
    const all = selector => (scope.querySelectorAll ? [...scope.querySelectorAll(selector)] : []);
    const radios = [...form.querySelectorAll('input[name="variant"]')];
    const allowedIds = new Set(radios.map(radio => radio.value));
    const button = form.querySelector('[data-hm-checkout]');
    const price = scope.querySelector('.hm-total [data-hm-price]');
    const summary = form.querySelector('[data-hm-order-summary]');
    const status = form.querySelector('[data-hm-status]');
    const sticky = scope.querySelector('[data-hm-sticky]');
    const stickyButton = scope.querySelector('[data-hm-sticky-buy]');
    const stickyLabel = scope.querySelector('[data-hm-sticky-label]');
    const lengthCurrent = scope.querySelector('[data-hm-length-current]');
    const termsId = scope.querySelector('[data-hm-terms-id]');
    let navigating = false;
    let refreshing = null;
    const lengths = form.querySelector('.hm-lengths');
    const calm = () => Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    // Text that changes with the length glides in instead of snapping.
    const swap = (node, text) => {
      if (!node || node.textContent === text) return;
      const first = node.textContent === '';
      node.textContent = text;
      if (first || calm() || typeof node.animate !== 'function') return;
      if (node.classList) node.classList.add('hm-swap');
      node.animate([{ opacity: 0, transform: 'translateY(0.35em)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
    };
    // The ink block slides from the previous length to the chosen one.
    const slide = radio => {
      const pill = radio.closest && radio.closest('.hm-length');
      if (!lengths || !lengths.style || !pill || !pill.offsetWidth) return;
      lengths.style.setProperty('--hm-pill-x', pill.offsetLeft + 'px');
      lengths.style.setProperty('--hm-pill-y', pill.offsetTop + 'px');
      lengths.style.setProperty('--hm-pill-w', pill.offsetWidth + 'px');
      lengths.style.setProperty('--hm-pill-h', pill.offsetHeight + 'px');
      if (lengths.dataset.hmSlide) return;
      lengths.dataset.hmSlide = 'set';
      window.setTimeout(() => { lengths.dataset.hmSlide = 'ready'; }, 60);
    };
    const selected = () => radios.find(radio => radio.checked);
    const canBuy = radio => Boolean(radio && allowedIds.has(radio.value) && radio.dataset.hmAvailable === 'true');
    const sync = (writeUrl = false) => {
      const radio = selected();
      if (!radio) return;
      const label = radio.dataset.hmLabel || radio.dataset.hmLength;
      swap(price, radio.dataset.hmPrice);
      slide(radio);
      summary.textContent = form.dataset.hmSummary.replace('__LENGTH__', radio.dataset.hmLength).replace('__VARIANT__', label) + ' · ' + radio.dataset.hmPrice;
      button.disabled = navigating || !canBuy(radio);
      status.textContent = canBuy(radio) ? form.dataset.hmReady : form.dataset.hmUnavailable;
      all('[data-hm-cta-price]').forEach(node => swap(node, radio.dataset.hmPrice));
      if (lengthCurrent) swap(lengthCurrent, label);
      if (stickyLabel) stickyLabel.textContent = label;
      if (stickyButton) stickyButton.disabled = button.disabled;
      if (termsId && termsId.value !== radio.value) {
        termsId.value = radio.value;
        termsId.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (writeUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        url.searchParams.delete('hd_lang');
        window.history.replaceState(null, '', url);
      }
      if (form.dispatchEvent) form.dispatchEvent(new CustomEvent('hairhd:variant', { bubbles: true, detail: { id: radio.value } }));
      updateReturns();
    };
    const restore = () => {
      navigating = false;
      button.removeAttribute('aria-busy');
      const id = new URL(window.location.href).searchParams.get('variant') || form.dataset.hmInitial;
      const target = radios.find(radio => radio.value === id) || radios[0];
      if (target) target.checked = true;
      sync();
    };
    const refresh = () => {
      if (refreshing) return refreshing;
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', form.dataset.hmSection);
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 8000);
      refreshing = fetch(url.href, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal })
        .then(response => { if (!response.ok) throw new Error(); return response.text(); })
        .then(html => {
          const fresh = [...new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-hm-purchase]')].find(item => item.dataset.hmProduct === form.dataset.hmProduct);
          if (!fresh || fresh.dataset.hmProduct !== form.dataset.hmProduct) throw new Error();
          const next = radios.map(radio => {
            const input = [...fresh.querySelectorAll('input[name="variant"]')].find(item => item.value === radio.value);
            if (!input) throw new Error();
            return { radio, input, label: input.closest('label').querySelector('.hm-length-copy') };
          });
          next.forEach(({ radio, input, label }) => {
            radio.dataset.hmPrice = input.dataset.hmPrice;
            radio.dataset.hmAvailable = fresh.dataset.hmLive === 'true' && input.dataset.hmAvailable === 'true' ? 'true' : 'false';
            radio.closest('label').querySelector('.hm-length-copy').replaceWith(label.cloneNode(true));
          });
          form.dataset.hmLive = fresh.dataset.hmLive;
          sync();
          return true;
        })
        .catch(() => {
          radios.forEach(radio => { radio.dataset.hmAvailable = 'false'; });
          sync();
          if (form.dataset.hmLive === 'true') status.textContent = form.dataset.hmError;
          return false;
        })
        .finally(() => { window.clearTimeout(timeout); refreshing = null; });
      return refreshing;
    };
    const checkout = async () => {
      const radio = selected();
      if (navigating || !canBuy(radio)) return;
      navigating = true;
      button.disabled = true;
      if (stickyButton) stickyButton.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = form.dataset.hmLoading;
      const verified = await refresh();
      const current = selected();
      if (!verified || !canBuy(current)) {
        navigating = false;
        button.removeAttribute('aria-busy');
        sync();
        if (!verified) status.textContent = form.dataset.hmError;
        return;
      }
      try {
        const path = form.dataset.hmCart.replace(/\/$/, '') + '/' + current.value + ':1';
        const url = new URL(path, window.location.origin);
        url.searchParams.set('locale', form.dataset.hmLocale);
        url.searchParams.set('checkout[shipping_address][country]', form.dataset.hmCountry);
        navigating = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.textContent = form.dataset.hmLoading;
        window.location.assign(url.href);
      } catch {
        navigating = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        status.textContent = form.dataset.hmError;
      }
    };
    radios.forEach(radio => radio.addEventListener('change', () => sync(true)));
    button.addEventListener('click', checkout);
    if (stickyButton) stickyButton.addEventListener('click', checkout);
    form.addEventListener('submit', event => { event.preventDefault(); checkout(); });
    window.addEventListener('pageshow', () => { restore(); refresh(); });
    window.addEventListener('popstate', restore);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
    window.setInterval(() => { if (!document.hidden && !navigating) refresh(); }, 60000);
    all('[data-hm-delivery]').forEach(node => {
      const text = deliveryText(node, form.dataset.hmLocale);
      if (text) node.textContent = text;
    });
    if (sticky) {
      const footer = document.querySelector('.hm-footer');
      let queued = false;
      const place = () => {
        queued = false;
        const height = window.innerHeight || 0;
        const passed = button.getBoundingClientRect().bottom < 0;
        const atFooter = footer ? footer.getBoundingClientRect().top < height : false;
        const visible = passed && !atFooter && scope.offsetParent !== null;
        sticky.dataset.visible = String(visible);
        sticky.setAttribute('aria-hidden', String(!visible));
        if (stickyButton) stickyButton.tabIndex = visible ? 0 : -1;
      };
      const schedule = () => {
        if (queued) return;
        queued = true;
        window.setTimeout(place, 60);
      };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      place();
    }
    window.addEventListener('resize', () => { const radio = selected(); if (radio) slide(radio); }, { passive: true });
    restore();
    refresh();
  });
  // Compact the consent app's banner on phones: same three choices, on one row.
  const compactConsent = () => {
    const host = document.querySelector('csm-cookie-consent');
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.querySelector('style[data-hm-consent]')) return true;
    const style = document.createElement('style');
    style.dataset.hmConsent = '';
    style.textContent = '@media (max-width:640px){.csm-cookie-box.csm-cookie-box{padding:10px 12px!important;margin:0!important;min-height:0!important;height:auto!important}.csm-ccb-content,.csm-ccb-content>div{margin:0!important;padding:0!important}.cc-message.cc-message,.cc-message.cc-message *{font-size:12.5px!important;line-height:1.35!important;margin:0!important;padding:0!important}.csm-ccb-buttons-wrapper.csm-ccb-buttons-wrapper{margin:8px 0 0!important;padding:0!important}.cc-compliance.cc-compliance.cc-compliance{display:flex!important;flex-direction:row-reverse!important;gap:6px!important;margin:0!important;padding:0!important}.cc-btn.cc-btn.cc-btn{flex:1 1 0!important;width:auto!important;min-width:0!important;min-height:36px!important;height:36px!important;margin:0!important;padding:0 4px!important;font-size:12.5px!important}}';
    host.shadowRoot.appendChild(style);
    return true;
  };
  if (typeof document !== 'undefined' && document.querySelector && typeof MutationObserver !== 'undefined' && !compactConsent()) {
    const consentWatch = new MutationObserver(() => { if (compactConsent()) consentWatch.disconnect(); });
    consentWatch.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => consentWatch.disconnect(), 15000);
  }
  updateReturns();
  if (typeof window !== 'undefined') window.HairHdDelivery = { addBusinessDays, deliveryText };
})();
